/* eslint-disable */
const getShowcaseState = (items, key, page) => {
  if (items.hasOwnProperty(key)) {
    const showcase = items[key];
    if (showcase.hasOwnProperty(page)) {
      return showcase[page];
    }
  }

  return null;
};

export default getShowcaseState;
